<template>
    <master-layout>
        
        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-user"></i> {{ $t('profile') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="box_infos_right">
            <div class="box_contents">
                <div class="card-box">
                    <div class="contact-card">
                        <PmlAvatar></PmlAvatar>
                        <div class="member-info">
                            <h4 class="m-t-0 m-b-5 header-title"><b>{{ member.full_name }}</b></h4>
                            <p class="text-dark"><i class="md md-business m-r-5"></i>{{ company.name }}</p>
                        </div>
                    </div>
                </div>
                <div class="card-box text-center">
                    <div class="row">
                        <div class="col-xs-12 col-sm-offset-1 col-sm-10">
                            <small class="show m-b-10 bold text-muted text-uppercase">{{ $t('desc_group_facebook') }}</small>
                        </div>
                    </div>
                    <a href="https://www.facebook.com/groups/pumpmylead" target="_blank" class="btn btn-facebook">
                        <span class="btn-label">
                            <i class="fa fa-facebook"></i>
                        </span>
                        Pump My Lead - Tribo
                    </a>
                </div>
                <ul class="nav nav-tabs menu_deals menu_vertical">
                    <router-link tag="li" :to="{ name: 'profile.info' }">
                        <a><i class="ti-user"></i><b>{{ $t('profile') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'profile.password' }">
                        <a><i class="fa fa-key"></i><b>{{ $t('change_password') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'profile.preferences' }">
                        <a><i class="ti-star"></i><b>{{ $t('preferences') }}</b></a>
                    </router-link>
                </ul>
            </div>
            <div class="box_contents">
                <div class="search-result-box">
                    <div class="card-box tab-content p-0">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import { mapGetters } from 'vuex'
    import PmlAvatar from './Avatar.vue'
    import { trans } from '@/utils/helpers/translation'

    export default {
        name: 'Profile',
        metaInfo () {
            return {
                title: trans('profile')
            }
        },
        components: { PmlAvatar },
        computed: {
            ...mapGetters({
                member: 'getMember',
                company: 'getCompany'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/Main.vue